import React from 'react';

import Association from './association';

import type { Project } from 'bundles/crm/associations/types';

interface Props {
  project: Project;
}

export default function ProjectAssociation({ project, ...props }: Props) {
  return (
    <Association
      {...props}
      header={project.displayName}
      key={project.id}
      path={project.path}
      subheader={`${project.status} / ${project.type}`}
    />
  );
}
